/**
 * UnderwayModals - Modal container for underway phase log entries
 */

import React from 'react';
import PositionModal from './modals/PositionModal';
import WeatherModal from './modals/WeatherModal';
import RadioModal from './modals/RadioModal';
import CourseModal from './modals/CourseModal';
import IncidentModal from './modals/IncidentModal';

const UnderwayModals = ({ 
  activeModal, 
  setActiveModal,
  positionData,
  setPositionData,
  weatherData,
  setWeatherData,
  radioData,
  setRadioData,
  courseData,
  setCourseData,
  incidentData,
  setIncidentData,
  getGPSPosition,
  logPosition,
  logWeather,
  logRadio,
  createIncidentReport,
  onAddLogEntry,
  activeVoyage
}) => {
  if (!activeModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        {activeModal === 'position' && (
          <PositionModal
            setActiveModal={setActiveModal}
            positionData={positionData}
            setPositionData={setPositionData}
            getGPSPosition={getGPSPosition}
            logPosition={logPosition}
          />
        )}
        
        {activeModal === 'weather' && (
          <WeatherModal
            setActiveModal={setActiveModal}
            weatherData={weatherData}
            setWeatherData={setWeatherData}
            logWeather={logWeather}
          />
        )}
        
        {activeModal === 'radio' && (
          <RadioModal
            setActiveModal={setActiveModal}
            radioData={radioData}
            setRadioData={setRadioData}
            logRadio={logRadio}
          />
        )}
        
        {activeModal === 'course' && (
          <CourseModal
            setActiveModal={setActiveModal}
            courseData={courseData}
            setCourseData={setCourseData}
            onAddLogEntry={onAddLogEntry}
            activeVoyage={activeVoyage}
          />
        )}
        
        {activeModal === 'incident' && (
          <IncidentModal
            setActiveModal={setActiveModal}
            incidentData={incidentData}
            setIncidentData={setIncidentData}
            createIncidentReport={createIncidentReport}
          />
        )}
      </div>
    </div>
  );
};

export default UnderwayModals;